export const analyticsMockData = {
  data: [
    {
      id: "1",
      hubId: "Alagomeji 2",
      createdAt: new Date().toLocaleDateString(),

      hubSupervisor: "Chidi Okeke",
      hubAttendant: "Khadijah Olawale",
      expectedCashBalance: "₦5,000,000.00",
    },
    {
      id: "2",
      hubId: "Alagomeji 2",
      createdAt: new Date().toLocaleDateString(),

      hubSupervisor: "Chidi Okeke",
      hubAttendant: "Khadijah Olawale",
      expectedCashBalance: "₦5,000,000.00",
    },
    {
      id: "3",
      hubId: "Alagomeji 2",
      createdAt: new Date().toLocaleDateString(),

      hubSupervisor: "Chidi Okeke",
      hubAttendant: "Khadijah Olawale",
      expectedCashBalance: "₦5,000,000.00",
    },
    {
      id: "3",
      hubId: "Alagomeji 2",
      createdAt: new Date().toLocaleDateString(),

      hubSupervisor: "Chidi Okeke",
      hubAttendant: "Khadijah Olawale",
      expectedCashBalance: "₦5,000,000.00",
    },
    {
      id: "3",
      hubId: "Alagomeji 2",
      createdAt: new Date().toLocaleDateString(),

      hubSupervisor: "Chidi Okeke",
      hubAttendant: "Khadijah Olawale",
      expectedCashBalance: "₦5,000,000.00",
    },
    {
      id: "3",
      hubId: "Alagomeji 2",
      createdAt: new Date().toLocaleDateString(),

      hubSupervisor: "Chidi Okeke",
      hubAttendant: "Khadijah Olawale",
      expectedCashBalance: "₦5,000,000.00",
    },
    {
      id: "3",
      hubId: "Alagomeji 2",
      createdAt: new Date().toLocaleDateString(),

      hubSupervisor: "Chidi Okeke",
      hubAttendant: "Khadijah Olawale",
      expectedCashBalance: "₦5,000,000.00",
    },
    {
      id: "3",
      hubId: "Alagomeji 2",
      createdAt: new Date().toLocaleDateString(),
      hubSupervisor: "Chidi Okeke",
      hubAttendant: "Khadijah Olawale",
      expectedCashBalance: "₦5,000,000.00",
    },
  ],
  pagination: {
    page: 1,
    pageSize: 10,
    totalRows: 40,
  },
};

export enum USER_ROLES {
  IBILE_AGENT = "IBILE_AGENT",
  PC_LIRS_AGENT = "PC_LIRS_AGENT",
  IBILE_AMBASSADOR = "IBILE_AMBASSADOR",
  IBILE_ADMIN = "IBILE_ADMIN",
}
